import { Box, BoxProps } from '@chakra-ui/react/box';

export type ColorBarProps = { color: BoxProps['color']; width?: string; height?: string } & Omit<
  BoxProps,
  'color' | 'width' | 'height'
>;
const ColorBar = ({ color, width = '8', height = 'auto', ...rest }: ColorBarProps) => (
  <Box width={width} height={height} backgroundColor={color} flexShrink={0} {...rest} />
);

export default ColorBar;
